export function isConstituentErrorData(data) {
    return 'errorCode' in data;
}
